import type { Href } from 'expo-router';

import {
  getSupportTeamByProductId,
  PRODUCT_SUPPORT_PREFILL_MESSAGES,
  PHARMA_TEAMS,
  PRODUCT_IDS,
  type ProductId,
} from '@/constants/medicalOnDemand';
import { ROUTES } from '@/constants/routes';

type PostSubmitSuccessParams = {
  isProductSupportSuccessFlagEnabled: boolean;
  productSupportParam?: string;
  productIdRaw?: string;
};

type ProductSupportPostSubmitSuccess = {
  kind: 'productSupportSuccess';
  prefillProductId?: ProductId;
  productName: string;
  productSupportHref: Href;
};

type DefaultPostSubmitSuccess = {
  kind: 'default';
};

export type PostSubmitSuccess = DefaultPostSubmitSuccess | ProductSupportPostSubmitSuccess;

function getProductName(productId?: ProductId): string {
  if (productId === 'talvey') {
    return 'Talvey';
  }

  if (productId === 'tecvayli') {
    return 'Tecvayli';
  }

  return 'product-specific';
}

export function getPostSubmitSuccess({
  isProductSupportSuccessFlagEnabled,
  productSupportParam,
  productIdRaw,
}: PostSubmitSuccessParams): PostSubmitSuccess {
  const isProductSupportEligible =
    isProductSupportSuccessFlagEnabled && productSupportParam === '1';

  if (!isProductSupportEligible) {
    return { kind: 'default' };
  }

  const prefillProductId =
    productIdRaw && PRODUCT_IDS.includes(productIdRaw as ProductId)
      ? (productIdRaw as ProductId)
      : undefined;

  const supportTeamId = prefillProductId
    ? getSupportTeamByProductId(prefillProductId)?.expertId
    : PHARMA_TEAMS[0]?.expertId;

  if (!supportTeamId) {
    return { kind: 'default' };
  }

  const productSupportHref =
    `${ROUTES.MEDICAL_ON_DEMAND_INQUIRY(String(supportTeamId))}?prefillSource=product_support_success${
      prefillProductId ? `&prefillProductId=${prefillProductId}` : ''
    }` as Href;

  return {
    kind: 'productSupportSuccess',
    prefillProductId,
    productName: getProductName(prefillProductId),
    productSupportHref,
  };
}

export function getPostSubmitSuccessPrefillMessage(params: {
  prefillProductId?: ProductId;
  prefillMessageParam?: string;
}): string | undefined {
  const { prefillProductId, prefillMessageParam } = params;

  if (!prefillProductId) {
    return undefined;
  }

  const messageFromUrl = typeof prefillMessageParam === 'string' ? prefillMessageParam.trim() : '';

  if (messageFromUrl.length > 0) {
    return messageFromUrl;
  }

  return PRODUCT_SUPPORT_PREFILL_MESSAGES[prefillProductId];
}

/** Backward-compatible alias for existing callsites/imports during rollout. */
export const getPostSubmitSuccessTestPrefillMessage = getPostSubmitSuccessPrefillMessage;
